// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTable-SkeletonIcon_cls1__8X+H+","cls2":"VeloTable-SkeletonIcon_cls2__8rAXj VeloTable-SkeletonIcon_cls1__8X+H+"};